interface ToggleProps {
  checked: boolean;
  onChange?: (next: boolean) => void;
  disabled?: boolean;
  size?: 'md' | 'sm';
  title?: string;
  'aria-label'?: string;
}

const SIZES = {
  md: { track: 'w-[46px] h-7', knob: 'w-[22px] h-[22px]', travel: 'translate-x-[18px]' },
  sm: { track: 'w-9 h-[22px]', knob: 'w-4 h-4', travel: 'translate-x-[14px]' },
} as const;

/**
 * The mobile app's switch (mobile/src/components/Toggle.tsx): a pill track the
 * height of its knob, orange when on, with an inner shadow along the top and
 * top-left so it reads as recessed, and a white knob inset all round.
 */
export function Toggle({ checked, onChange, disabled, size = 'md', title, ...aria }: ToggleProps) {
  const s = SIZES[size];
  return (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      aria-label={aria['aria-label']}
      title={title}
      disabled={disabled || !onChange}
      onClick={() => onChange?.(!checked)}
      className={`relative inline-flex flex-shrink-0 items-center rounded-full p-[3px] transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-orange focus-visible:ring-offset-2 focus-visible:ring-offset-card disabled:opacity-50 disabled:cursor-not-allowed ${s.track} ${
        checked ? 'bg-brand-orange' : 'bg-gray-300 dark:bg-gray-600'
      }`}
      style={{
        boxShadow:
          'inset 1px 2px 3px rgb(0 0 0 / 0.26), inset 0 0 0 0.5px rgb(0 0 0 / 0.12)',
      }}
    >
      <span
        className={`rounded-full bg-gradient-to-b from-white to-[#eceef1] transition-transform duration-150 ease-out ${s.knob} ${
          checked ? s.travel : 'translate-x-0'
        }`}
        style={{ boxShadow: '0 2px 3px rgb(0 0 0 / 0.28)' }}
      />
    </button>
  );
}
